'use client';
import { createContext, useContext } from 'react';

import { FreimaurerPersonRepository } from '@/repositories/freimaurerPersonRepository.ts';
import { FreimaurerRepository } from '@/repositories/freimaurerRepository.ts';
import { ImpfstudienRepository } from '@/repositories/impfstudienRepository.ts';
import { InobhutnahmeRepository } from '@/repositories/inobhutnahmeRepository.ts';
import { JustizversagenRepository } from '@/repositories/justizversagenRepository.ts';
import { KrisenprofitRepository } from '@/repositories/krisenprofitRepository.ts';
import { MedienverleumdungRepository } from '@/repositories/medienverleumdungRepository.ts';
import { MobilfunkStudienRepository } from '@/repositories/mobilfunkStudienRepository.ts';
import { PharmaMedizinopferRepository } from '@/repositories/pharmaMedizinopferRepository.ts';
import { RitualgewaltRepository } from '@/repositories/ritualgewaltRepository.ts';
import { WahlbetrugRepository } from '@/repositories/wahlbetrugRepository.ts';
import { ZensierteErfindungRepository } from '@/repositories/zensierteErfindungRepository.ts';

import { DataFetcher } from '../repositories/fetcher/DataFetcher';
import { MobilfunkRepository } from '../repositories/mobilfunkRepository.ts';
import { VaxRepository } from '../repositories/vaxRepository.ts';

export interface IRepositoriesContext {
  mobilfunkRepository: MobilfunkRepository;
  impfstudienRepository: ImpfstudienRepository;
  inobhutnahmeRepository: InobhutnahmeRepository;
  freimaurerRepository: FreimaurerRepository;
  freimaurerPersonRepository: FreimaurerPersonRepository;
  vaxRepository: VaxRepository;
  ritualgewaltRepository: RitualgewaltRepository;
  krisenprofitRepository: KrisenprofitRepository;
  mobilfunkStudienRepository: MobilfunkStudienRepository;
  pharmaMedizinopferRepository: PharmaMedizinopferRepository;
  medienverleumdungRepository: MedienverleumdungRepository;
  wahlbetrugRepository: WahlbetrugRepository;
  justizversagenRepository: JustizversagenRepository;
  zensierteErfindungRepository: ZensierteErfindungRepository;
}

export const RepositoryContext = createContext<IRepositoriesContext>(undefined!);
RepositoryContext.displayName = 'RepositoryContext';

export function generateRepository(): IRepositoriesContext {
  const dataFetcher = new DataFetcher();

  return {
    mobilfunkRepository: new MobilfunkRepository(dataFetcher),
    inobhutnahmeRepository: new InobhutnahmeRepository(dataFetcher),
    impfstudienRepository: new ImpfstudienRepository(dataFetcher),
    freimaurerRepository: new FreimaurerRepository(dataFetcher),
    freimaurerPersonRepository: new FreimaurerPersonRepository(dataFetcher),
    vaxRepository: new VaxRepository(dataFetcher),
    ritualgewaltRepository: new RitualgewaltRepository(dataFetcher),
    krisenprofitRepository: new KrisenprofitRepository(dataFetcher),
    mobilfunkStudienRepository: new MobilfunkStudienRepository(dataFetcher),
    pharmaMedizinopferRepository: new PharmaMedizinopferRepository(dataFetcher),
    medienverleumdungRepository: new MedienverleumdungRepository(dataFetcher),
    wahlbetrugRepository: new WahlbetrugRepository(dataFetcher),
    justizversagenRepository: new JustizversagenRepository(dataFetcher),
    zensierteErfindungRepository: new ZensierteErfindungRepository(dataFetcher)
  };
}

export const useRepositories = () => useContext(RepositoryContext);
